import React from "react";
import ReactDOM from "react-dom/client";
import axios from "axios";
import "@/index.css";
import App from "@/App";
import { installErrorReporter, installAxiosErrorInterceptor } from "@/lib/errorReporter";
import { registerServiceWorker } from "@/lib/registerSw";

// Wire self-hosted error tracking ASAP so we catch errors during initial render too.
installErrorReporter();
installAxiosErrorInterceptor(axios);
registerServiceWorker();

// May 26 2026 — bump the global axios default timeout from 10s to 30s.
// Several legacy callers don't pass an explicit `timeout` option and
// were hitting the implicit 10s ceiling under upstream Gemini load,
// which surfaced as raw "AxiosError: timeout of 10000ms exceeded"
// notifications. Endpoints that need more time (AI preview, file
// upload, etc.) still pass explicit higher values.
axios.defaults.timeout = 30000;

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
